module.exports = __webpack_public_path__ + "static/img/p2b-1.83e3daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/p2b-1.jpg
// module id = Fga4
// module chunks = 1